import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-member-stats',
    standalone: true,
    templateUrl: './memberStats.component.html',
    styleUrls: ['./memberStats.component.scss'],
    imports: [CommonModule],
})
export class MemberStatsComponent {
    @Input() numberOfRaces = 0;
    @Input() bestPlacement?: number;
    @Input() bestPlacementCircuit?: string;
    @Input() firstRaceDate?: string;
    @Input() numberOfIncidents = 0;
}
